import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    data: String
  }

  connect() {
    // Parse the celebration data
    const celebrations = this.hasDataValue ? JSON.parse(this.dataValue) : []

    if (celebrations.length === 0) {
      this.element.remove()
      return
    }

    // Find or create modal container
    let modalContainer = document.getElementById("modal-container")
    if (!modalContainer) {
      modalContainer = document.createElement("div")
      modalContainer.id = "modal-container"
      document.body.appendChild(modalContainer)
    }

    // Insert each celebration modal
    celebrations.forEach((celebration, index) => {
      if (celebration.html) {
        // Add a small delay between modals if there are multiple
        setTimeout(() => {
          modalContainer.insertAdjacentHTML("beforeend", celebration.html)
        }, index * 500)
      }
    })

    // Remove this element to prevent duplicate triggers
    this.element.remove()
  }
}
